import { Download } from "lucide-react";
import { CategoryTag } from "@/components/skills/CategoryTag";
import { RiskBadge } from "@/components/skills/RiskBadge";
import { Stars } from "@/components/skills/Stars";
import type { SkillDetail } from "@/hooks/use-skill";
import { initials } from "@/lib/skills/format";

export function SkillHero({ skill }: { skill: SkillDetail }) {
  return (
    <header className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center gap-2">
        {skill.cat.map((c) => (
          <CategoryTag key={c} category={c} />
        ))}
        <RiskBadge level={skill.risk} />
        {!skill.published ? (
          <span className="rounded-full bg-bg-3 px-2 py-0.5 text-xs font-semibold text-fg-3">
            Unpublished
          </span>
        ) : null}
      </div>
      <h1 className="font-display text-[30px] font-bold leading-tight text-fg-1">{skill.title}</h1>
      <p className="max-w-2xl text-fg-2">{skill.desc}</p>
      <div className="mt-1 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="grid size-7 place-items-center rounded-full bg-bg-2 text-xs font-semibold text-fg-link">
            {initials(skill.authorName)}
          </span>
          <div className="leading-tight">
            <div className="text-sm font-semibold text-fg-1">{skill.authorName}</div>
            {skill.authorTeam ? (
              <div className="text-[11px] text-fg-3">{skill.authorTeam}</div>
            ) : null}
          </div>
        </div>
        <span className="h-7 w-px bg-border-1" />
        <Stars value={skill.rating} count={skill.ratingCount} />
        <span className="h-7 w-px bg-border-1" />
        <span className="flex items-center gap-1.5 text-sm text-fg-2">
          <Download className="size-4" />
          {skill.downloads.toLocaleString()} downloads
        </span>
      </div>
    </header>
  );
}
